import React, { useState, } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { getEnvironmentsforUser } from '../api/documentAPI';
import { useMsal } from "@azure/msal-react";
import { useNotification } from '../context/NotificationContext';
import { NotificationType } from '../enums/NotificationType';

import axios from '../api/axios';
import useCookie from "../hooks/useCookie";
import useAuth from '../hooks/useAuth';
import config from '../config/configJS';

import '../css/pages/login_page.css';
import '../css/loading_animation.css';

const LoginForm = () => {
  
  const [t] = useTranslation('global');
  const { showNotification } = useNotification();
  const { instance } = useMsal();
  const { setAuth } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ username: '', password: '' });  

  const [envCookie, setEnvCookie, ] = useCookie("ENV");  

  const handleLogin = async (loginType) => {

    if (loginType === "popup") {
      setIsLoading(true);
      instance.loginPopup({
        scopes: ["User.Read", "Group.Read.All"]
      }).then(async (response) => {

        const accessToken = await instance.acquireTokenSilent({
          account: response.account,
          scopes: ["User.Read", "Group.Read.All"]
        });

        const r1 = await axios.post("/api/auth/Ad", { Token: accessToken.accessToken }, { withCredentials: true });
        const { data: user } = await axios.post("/api/auth/GetUserByCookie", {}, { withCredentials: true });

        await handlePostLogin(user);
        return false;

      }).catch((error) => {
        console.log(error);
        setIsLoading(false);
      });

    } else if (loginType === "redirect") {
      instance.loginRedirect({
        scopes: ["User.Read"],
        //redirectUri: window.location.origin
      });
    }

    // if (loginType === "redirect") {
    //   try {
    //     setIsLoading(true);
    //     // First check if we have a redirect response
    //     const response = await instance.handleRedir  ectPromise();
        
    //     if (response) {
    //       // If we have a response, process it
    //       const accessToken = await instance.acquireTokenSilent({
    //         account: response.account,
    //         scopes: ["User.Read", "Group.Read.All"],
    //       });

    //       await axios.post(
    //         "/api/auth/Ad",
    //         { Token: accessToken.accessToken },
    //         { withCredentials: true }
    //       );
          
    //       const { data: user } = await axios.post(
    //         "/api/auth/GetUserByCookie",
    //         {},
    //         { withCredentials: true }
    //       );

    //       await handlePostLogin(user);
    //     } else {
    //       // If no response, initiate the login
    //       await instance.loginRedirect({
    //         scopes: ["User.Read", "Group.Read.All"]
    //       });
    //     }
    //   } catch (error) {
    //     console.error("Error during login:", error);
    //     setIsLoading(false);
    //     showNotification({ message: t('authError'), type: NotificationType.Error });
    //   }
    // }
  };

  const handleChangeEmail = (e) => {
    const { name, value } = e.target;
    let noDiacritics = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    setFormData({ ...formData, [name]: noDiacritics });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    let auth = {
      username: formData.username,
      password: formData.password,
    };  
    
    try {
      await axios.post("/api/auth/Authenticate", {}, { auth, withCredentials: true });
      const { data: user } = await axios.post("/api/auth/GetUserByCookie", {}, { withCredentials: true });

      await handlePostLogin(user);

    } catch (error) {
      showNotification({ message: t('authError'), type: NotificationType.Error });
      setIsLoading(false);
    }
  };

  const handlePostLogin = async (user) => {

    const { id, userFirstname, userLastname, userEmail, isActive, roleId } = user;
    setAuth({ 
      uid: id, 
      ufn: userFirstname, 
      uln: userLastname, 
      uem: userEmail, 
      uia: isActive, 
      uri: roleId 
    });

    await validateAndSetCookie();
    
    navigate("/");
    //navigate(from);
  };

  const validateAndSetCookie = async () => {

    try {
      const environments = await getEnvironmentsforUser(); 

      if (!envCookie || !isValidEnvForUser(envCookie, environments)) {
        const defaultEnv = environments[0]?.Id || null; 
        if (defaultEnv) {
          setEnvCookie("ENV", defaultEnv, { maxAge: 86400 });
        }
      }
    } catch (error) {
      console.error("Error validating environment cookie:", error);
    }
  }

  const isValidEnvForUser = (envCookie, environments) => {
    const value =  environments.some(env => env.Id === envCookie);
    return value;
  };

  return (
    <div className='login-page'>

      <form onSubmit={handleSubmit} className="login-form">

        <div className="milladaTitle">
            <div className='text-drop'>
            <div className='mi'>Mi</div>
            <div className='ll'>
              <span className="stripe-1">l</span>
              <span className="stripe-2">l</span>
            </div>
            <div className='ada'>ada</div>
          </div>
        </div>
         
        <div className="milladaSubtitle">{t('login')}</div>
        <div className="login-inputs">
        {config.jwtAllowed ? 
          <>
          <div>
            <input
              type="text"
              id="username"
              name="username"
              placeholder={t('email')}
              value={formData.username}
              onChange={handleChangeEmail}
            />
          </div>
          <div>
            <input
              type="password"
              id="password"
              name="password"
              placeholder={t('password')}
              value={formData.password}
              onChange={handleChange}
            />
          </div>
          <button
            type="submit"
            id="logIn"
            disabled={isLoading}>
            {t('loginNow')}
            </button>
          </>
        : null }

        {config.adAllowed ? 
          <button
            type="button"
            id="ad"
            disabled={isLoading}
            onClick={() => handleLogin("redirect")}>AD Sign In</button>
        : null }
        </div>
        {isLoading ? <div className="lds-ellipsis">
          <div></div>
          <div></div><div></div><div></div></div> : ''}
      </form>
    </div>
  );
};

export default LoginForm;
